import { createBrowserHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { install } from 'redux-loop';

import { setupIntl } from '../intl';  // NOTICE: 'intl' is a node package
import createRootReducer from 'reducers';

const history = createBrowserHistory();

/**
 * Navigate programmatically from outside React components (e.g. reducers).
 * Works with both history v4 (push) and v5 (push → navigate).
 */
export const navigateTo = (url, options) => {
  history.push(url, options);
};

const middlewares = [ /* Add middlewares here */ ];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const initialState = {
  intl: setupIntl(),
};

export default function configureStore() {
  const store = createStore(
    createRootReducer (history),
    initialState,
    composeEnhancers(install(), applyMiddleware(...middlewares))
  );

  if (module.hot) {
    module.hot.accept('../reducers/index', () => {
      const nextRootReducer = require('../reducers/index');
      store.replaceReducer(nextRootReducer);
    });
  }
  return store;
}
export { history };

